// lib
import { useMemo } from 'react'
import PropTypes from 'prop-types'

import { encodeText } from '@aytm/app/stats/lib/util/helpers'
import { itemTemplate, valueTemplate } from '@aytm/app/stats/page/components/lib/templates'
import { pressable } from '@aytm/app/stats/components/lib/pressable'

// components
import { Dropdown } from 'primereact/dropdown'

// styles
import style from '@aytm/app/stats/page/sidebar/view-options/styles/ViewOptionsPanel.module.scss'

const Demographic = ({ model, data, features, onTraitChange }) => {
  const { trait } = model
  const { traits, variables, pipingVariables, customVariables, virtual } = data

  const demographicOptions = useMemo(() => {
    let options = []

    options = options.concat(
      traits.map(t => {
        // Title is researcher-supplied and the option label renders as innerHTML; encode it
        // so a hostile title stays inert text (virtual questions / variables keep markup). OQ-17.
        return { key: ('age' == t.id && 'age_range') || t.id, text: encodeText(t.title) }
      })
    )

    options = options.concat(
      virtual.map(q => {
        return { key: q.id, text: q.id.toUpperCase() }
      })
    )

    options = options.concat(
      variables.map(key => {
        return { key, text: key }
      })
    )
    options = options.concat(
      pipingVariables.map(key => {
        return { key, text: key }
      })
    )
    options = options.concat(
      customVariables.map(key => {
        return { key, text: key }
      })
    )

    return options
  }, [traits, variables, pipingVariables, customVariables, virtual])

  return (
    <div className={style.section}>
      <div className={style['section-title']}>Split all charts by a demographic</div>

      <div className={`${style.row} ${style['row-indent']}`}>
        {trait ? (
          <span
            className={style.delete}
            aria-label="Clear demographic"
            {...pressable(features.view_options.disabled ? null : () => onTraitChange(null))}
          >
            <i className="icon-aytmfd-x-v2" />
          </span>
        ) : null}
        <div className="p-fluid p-col-12">
          <Dropdown
            data-testid="stat-view-options-demographic"
            className="p-dropdown-rounded"
            placeholder="Select..."
            value={trait}
            options={demographicOptions}
            optionValue="key"
            optionLabel="text"
            optionDisabled="disabled"
            itemTemplate={itemTemplate}
            valueTemplate={valueTemplate}
            fixedDropdownDir="bottom"
            disabled={features.view_options.disabled}
            onChange={features.view_options.disabled ? null : event => onTraitChange(event.value)}
          />
        </div>
      </div>
    </div>
  )
}

Demographic.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  features: PropTypes.object,
  disabled: PropTypes.bool,
  onTraitChange: PropTypes.func
}

Demographic.displayName = 'Demographic'

export default Demographic
